/** @format */

import React, { useState, useEffect } from "react";
import { projectStorage } from "components/ProjectStorage";

const DataAnalysisTab = ({ outputHtml }) => {
  const [htmlUrl, setHtmlUrl] = useState("");
  /** 데이터 분석 목록 받아오기 */
  useEffect(async () => {
    if (outputHtml) {
      /** csv 파일 읽기 */
      const storageFileRef = projectStorage.ref(outputHtml);
      storageFileRef
        .getDownloadURL()
        .then(function (url) {
          setHtmlUrl(url);
        })
        .catch(function (error) {
          console.log("error :", error);
        });
    }
  }, []);

  return (
    <div className="border-table">
      <div className="full mx-auto data-style">
        <div
          className="w-full h-full"
          dangerouslySetInnerHTML={{
            __html: `<iframe src="${htmlUrl}"  width="100%"  style="height:700px" />`,
          }}
        />
      </div>
    </div>
  );
};

export default DataAnalysisTab;
